/**
 * [AI補完仕様] このコメントはAI補完（コード自動生成）に構造情報として渡されます。変更時は実装品質に直結するため正確に保つこと。
 *
 * 認証ガード — 未認証ユーザーにはLoginPageを表示、ロール不一致にはアクセス拒否を表示する。
 *
 * @contract フロントエンドプラグイン（plugins/）はProtectedRouteの内側で動作する。未認証状態ではアクセス不可。
 * @contract 未認証ユーザー向け画面（ユーザー登録等）はProtectedRoute外に配置するか、LoginPage内に統合すること。
 * @contract isInitializing中（Cookie経由のセッション復元判定中）はLoginPageを表示せず何も描画しないこと（未認証と誤判定してのフラッシュを防ぐ）。
 * @signature ProtectedRoute: FC<{ children, allowedRoles?: string[] }>
 */
import React from 'react';
import { useAuth } from './auth-context';
import { LoginPage } from './LoginPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, user, isInitializing } = useAuth();

  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (allowedRoles && user && !user.roles.some(r => allowedRoles.includes(r))) {
    return (
      <div className="access-denied">
        <h2>アクセス権限がありません</h2>
        <p>この画面を表示する権限がありません（現在のロール: {user.displayName}）</p>
      </div>
    );
  }

  return <>{children}</>;
}
